/// <reference types='@angular/localize' />

import '@angular/common/locales/global/de-CH';

import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [...appConfig.providers]
}).catch(err => console.error(err));
